import { Component } from '@opten/gin-tonic/helpers/compiler';
import { Filter } from './index';
import { Mixit } from '@opten/gin-tonic/components/mixitup';

@Component({className: 'js-filter-group'})
export class FilterComponent {
	private mixit: Mixit;
	private selects: Filter[] = [];

	constructor(private element: HTMLElement) {
		this.mixit = new Mixit(element, {multifilter: true});
		element.querySelectorAll<HTMLSelectElement>('.js-filter').forEach(filter => {
			filter.addEventListener('change', this.filterBy.bind(this));
			const filterItem = new Filter(filter);
			this.selects.push(filterItem);
		});
	}

	private filterBy() {
		const filters = this.selects.map(filter => {
			const val = filter.getSelectedOption();
			return val.length > 0 ? '.' + val : '';
		}).join('');
		this.mixit.filter(filters);
	}
}
